import { useEffect, useState } from "react";
import { Formik } from "formik";
import { Grid, TextField, FormLabel, Autocomplete, Button, FormControlLabel, Checkbox } from "@mui/material";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { useUbigeoStore } from "../../../hooks/useUbigeoStore";
import CustomTable from "../../../components/common/CustomTable/CustomTable";
import { CustomSnackbar } from "../../../components/common/CustomSnackbar/CustomSnackbar";

type ValuesAddress = {
    idcountry: number | undefined,
    country: string,
    iddepartment: number | undefined,
    department: string,
    idprovince: number | undefined,
    province: string,
    iddistrict: number | undefined,
    district: string,
    address: string,
    alias?: string,
    is_billable: string
}

const columns = [
    { type: 'text', field: 'address', label: 'Dirección', align: 'center' },
    { type: 'text', field: 'alias', label: 'Alias', align: 'center' },
    { type: 'text', field: 'is_billable', label: 'Es facturable', align: 'center', format: (row) => row.is_billable === '1' ? 'SI' : 'NO' },
    { type: 'text', field: 'district', label: 'Comuna', align: 'center' },
    { type: 'text', field: 'province', label: 'Provincia', align: 'center' },
    { type: 'text', field: 'department', label: 'Departamento', align: 'center' },
    { type: 'text', field: 'country', label: 'Pais', align: 'center' },
    { type: 'options', field: '', label: '', align: '' },
];

export const SectionMainAddress: React.FC<any> = (props): JSX.Element | any => {

    const { action, clientAddresses, setClientAddresses, currentSection, handlePrevSection, handleNextSection, sections, clearState } = props;

    const [data, setData] = useState<ValuesAddress>({
        idcountry: undefined,
        country: '',
        iddepartment: undefined,
        department: '',
        idprovince: undefined,
        province: '',
        iddistrict: undefined,
        district: '',
        address: '',
        alias: undefined,
        is_billable: '0'
    });

    const { getCountries, getDepartments, getProvinces, getDistricts } = useUbigeoStore();

    const [loadingdata, setLoadingdata] = useState<boolean>(false);
    const [loadingtable, setLoadingtable] = useState<boolean>(false);
    const [countries, setCountries] = useState<any>([]);
    const [countryselected, setCountrySelected] = useState<any>('');
    const [departments, setDepartments] = useState<any>([]);
    const [departmentselected, setDepartmentSelected] = useState<any>('');
    const [provinces, setProvinces] = useState<any>([]);
    const [provinceselected, setProvinceSelected] = useState<any>('');
    const [districts, setDistricts] = useState<any>([]);
    const [districtselected, setDistrictSelected] = useState<any>('');
    const [editingAddress, setEditingAddress] = useState<ValuesAddress | null>(null);

    useEffect(() => {
        getDistrictsApi()
    }, [])

    useEffect(() => {
        if (data.idcountry && countries) {
            setCustomCountry(data.idcountry, countries)
            getDepartmentsApi(data.idcountry.toString())
        }
    }, [data.idcountry, countries])

    useEffect(() => {
        if (data.iddepartment && departments) {
            setCustomDepartment(data.iddepartment, departments)
            getProvincesApi(data.iddepartment.toString())
        }
    }, [data.iddepartment, departments])

    useEffect(() => {
        if (data.idprovince && provinces) {
            setCustomProvince(data.idprovince, provinces)
            getDistrictsApi(data.idprovince.toString())
        }
    }, [data.idprovince, provinces])

    useEffect(() => {
        if (data.iddistrict && districts) {
            setCustomDistrict(data.iddistrict, districts)
        }
    }, [data.iddistrict, districts])

    const getCountriesApi = async () => {
        try {
            setLoadingdata(true);
            const response = await getCountries();
            if (!response) {
                setCountries([]);
                setLoadingdata(false);
                return false;
            } else {
                setCountries(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getDepartmentsApi = async (idcountry = '') => {
        try {
            setLoadingdata(true);
            const response = await getDepartments('', idcountry);
            if (!response) {
                setDepartments([]);
                setLoadingdata(false);
                return false;
            } else {
                setDepartments(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getProvincesApi = async (iddeparment = '') => {
        try {
            setLoadingdata(true);
            const response = await getProvinces('', iddeparment);
            if (!response) {
                setProvinces([]);
                setLoadingdata(false);
                return false;
            } else {
                setProvinces(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getDistrictsApi = async (idprovince = '') => {
        try {
            setLoadingdata(true);
            const response = await getDistricts('', idprovince);
            if (!response) {
                setDistricts([]);
                setLoadingdata(false);
                return false;
            } else {
                setDistricts(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const setCustomCountry = (idcountry, countries) => {
        const data = countries.find(country => country.id == idcountry);
        return setCountrySelected(data);
    }
    const setCustomDepartment = (iddepartment, departments) => {
        const data = departments.find(department => department.id == iddepartment);
        return setDepartmentSelected(data);
    }
    const setCustomProvince = (idprovince, provinces) => {
        const data = provinces.find(province => province.id == idprovince);
        return setProvinceSelected(data);
    }
    const setCustomDistrict = (iddistrict, districts) => {
        const data = districts.find(district => district.id == iddistrict);
        return setDistrictSelected(data);
    }

    const validateForm = (values) => {
        let errors: any = {};
        // if(!values.idcountry) errors.idcountry = "el campo es requerido";
        // if(!values.iddepartment) errors.iddepartment = "el campo es requerido";
        // if(!values.idprovince) errors.idprovince = "el campo es requerido";
        // if(!values.iddistrict) errors.iddistrict = "el campo es requerido";
        // if(!values.address) errors.address = "el campo es requerido";
        return errors;
    }

    const onDelete = (rowSelected: any) => {
        const clientAddressesFilter = clientAddresses.filter(clientAddress => clientAddress.n !== rowSelected.n)
        setClientAddresses([...clientAddressesFilter])
    }

    const addClientAddresses = (values) => {
        if (editingAddress) {
            // Si estamos editando, actualizar la dirección en la lista
            setClientAddresses(clientAddresses.map(addr =>
                addr.address === editingAddress.address ? { ...values } : addr
            ));
            setEditingAddress(null);
        } else {
            // Si la nueva dirección es facturable (1), desmarcar las demás
            const updatedAddresses = values.is_billable === '1'
                ? clientAddresses.map(addr => ({ ...addr, is_billable: '0' }))
                : [...clientAddresses];
    
            setClientAddresses([...updatedAddresses, { ...values, id: null }]);
        }
    };    

    const onEdit = (rowSelected: any) => {
        setEditingAddress(rowSelected);
    };

    const onSubmit = async (values) => {
        if (clientAddresses.length === 0) {
            return CustomSnackbar('warning', 'Ingrese al menos una dirección.');
        }

        const billableAddresses = clientAddresses.filter(addr => addr.is_billable === '1');

        if (billableAddresses.length === 0) {
            return CustomSnackbar('warning', 'Debe seleccionar una dirección como facturable.');
        }
    
        if (billableAddresses.length > 1) {
            return CustomSnackbar('warning', 'Solo puede haber una dirección facturable.');
        }

        setData && setData(values);
        handleNextSection && handleNextSection();
        setEditingAddress(null); // Limpiar el estado de edición después de guardar
    };

    const onCancel = () => {
        handlePrevSection && handlePrevSection();
    }

    return (
        <Grid sx={{ height: '100%', position: 'relative' }}>
            <Formik initialValues={editingAddress || data} enableReinitialize validate={(values) => validateForm(values)} onSubmit={onSubmit}>
                {({ values, errors, touched, handleSubmit, handleChange, setFieldValue }) => {
                    return (
                        <form onSubmit={handleSubmit} autoComplete="off">
                            <Grid container sx={{ maxHeight: '65vh', overflowY: 'scroll', paddingRight: '5px' }}>
                                <Grid item container xs={12} spacing={2}>
                                    {/* <Grid item xs={12} md={6}>
                                        <FormLabel>País:</FormLabel>
                                        <Autocomplete
                                            id="idcountry"
                                            size="small"
                                            value={!!countryselected ? countryselected : null}
                                            options={countries || []}
                                            loading={loadingdata}
                                            getOptionLabel={(option) => option?.name || ''}
                                            isOptionEqualToValue={(option, value) => option.name === value?.name}
                                            renderInput={(params) =>
                                                <TextField {...params} label="" size="small" autoComplete="off"
                                                    error={errors.idcountry && touched.idcountry ? true : false}
                                                />
                                            }
                                            onChange={(e, newValue: any) => {
                                                setCountrySelected(newValue)
                                                setFieldValue('idcountry', newValue ? newValue.id : "");
                                                if (newValue) getDepartmentsApi(newValue.id); setFieldValue('country', newValue.name);

                                                setDepartmentSelected("");
                                                setProvinceSelected("");
                                                setDistrictSelected("");
                                            }}

                                        />
                                    </Grid> */}
                                    {/* <Grid item xs={12} md={6}>
                                        <FormLabel>Región:</FormLabel>
                                        <Autocomplete
                                            id="iddepartment"
                                            size="small"
                                            value={!!departmentselected ? departmentselected : null}
                                            options={departments || []}
                                            loading={loadingdata}
                                            getOptionLabel={(option) => option?.name || ''}
                                            isOptionEqualToValue={(option, value) => option.name === value?.name}
                                            renderInput={(params) =>
                                                <TextField {...params} label="" size="small" autoComplete="off"
                                                    error={errors.iddepartment && touched.iddepartment ? true : false}
                                                />
                                            }
                                            onChange={(e, newValue: any) => {
                                                setDepartmentSelected(newValue)
                                                setFieldValue('iddepartment', newValue ? newValue.id : "");
                                                if (newValue) getProvincesApi(newValue.id); setFieldValue('department', newValue.name);

                                                setProvinceSelected("");
                                                setDistrictSelected("");
                                            }}

                                        />
                                    </Grid> */}
                                    {/* <Grid item xs={12} md={6}>
                                        <FormLabel>Provincia:</FormLabel>
                                        <Autocomplete
                                            id="idprovince"
                                            size="small"
                                            value={!!provinceselected ? provinceselected : null}
                                            options={provinces || []}
                                            loading={loadingdata}
                                            getOptionLabel={(option) => option?.name || ''}
                                            isOptionEqualToValue={(option, value) => option.name === value?.name}
                                            renderInput={(params) =>
                                                <TextField {...params} label="" size="small" autoComplete="off"
                                                    error={errors.idprovince && touched.idprovince ? true : false}
                                                />
                                            }
                                            onChange={(e, newValue: any) => {
                                                setProvinceSelected(newValue)
                                                setFieldValue('idprovince', newValue ? newValue.id : "");
                                                if (newValue) getDistrictsApi(newValue.id); setFieldValue('province', newValue.name);

                                                setDistrictSelected("");
                                            }}

                                        />
                                    </Grid> */}
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Comuna:</FormLabel>
                                        <Autocomplete
                                            id="iddistrict"
                                            size="small"
                                            value={!!districtselected ? districtselected : null}
                                            options={districts || []}
                                            loading={loadingdata}
                                            getOptionLabel={(option) => option?.name +
                                                (option?.province?.name ? ' - ' + option?.name : '') || ''}
                                            isOptionEqualToValue={(option, value) => option.name === value?.name}
                                            renderInput={(params) =>
                                                <TextField {...params} label="" size="small" autoComplete="off"
                                                    error={errors.iddistrict && touched.iddistrict ? true : false}
                                                />
                                            }
                                            onChange={(e, newValue: any) => {
                                                setDistrictSelected(newValue)
                                                setFieldValue('iddistrict', newValue ? newValue.id : "");
                                                setFieldValue('district', newValue?.name);
                                            }}

                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Dirección:</FormLabel>
                                        <TextField
                                            id="address"
                                            type="text"
                                            name="address"
                                            fullWidth
                                            size="small"
                                            autoComplete="off"
                                            value={values.address}
                                            onChange={handleChange}
                                            error={errors.address && touched.address ? true : false}
                                            inputProps={{ readOnly: action == 'detail' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Alias:</FormLabel>
                                        <TextField
                                            id="alias"
                                            type="text"
                                            name="alias"
                                            fullWidth
                                            size="small"
                                            autoComplete="off"
                                            value={values.alias}
                                            onChange={handleChange}
                                            error={errors.alias && touched.alias ? true : false}
                                            inputProps={{ readOnly: action == 'detail' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6} sx={{ mt: 3 }}>
                                        <FormLabel>Dirección facturable: </FormLabel>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={values.is_billable === '1'}
                                                    onChange={(e) => setFieldValue('is_billable', e.target.checked ? '1' : '0')}
                                                    name="is_billable"
                                                />
                                            }
                                            label=""
                                        />

                                    </Grid>

                                    <Grid item xs={12}>
                                        <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="center">
                                            {/* Texto alineado a la izquierda */}
                                            <FormLabel>Lista de direcciones</FormLabel>

                                            {/* Botones alineados a la derecha */}
                                            <Grid item display="flex" gap={2} justifyContent="flex-end">
                                                <Button onClick={() => addClientAddresses(values)} size="small" variant="contained" className="btn-secondary">
                                                    {editingAddress ? 'Guardar cambios' : 'Añadir'}
                                                </Button>
                                                {editingAddress && (
                                                    <Button onClick={() => setEditingAddress(null)} size="small" variant="contained" className="btn-secondary">
                                                        Cancelar Edición
                                                    </Button>
                                                )}
                                            </Grid>
                                        </Grid>


                                        <CustomTable
                                            disabled_title
                                            columns={columns}
                                            loading={loadingtable}
                                            rows={clientAddresses || []}
                                            onRowClick={() => { }}
                                            hasOptions
                                            // onDelete={onDelete}
                                            onEdit={onEdit}
                                            RowsPerPage={3}
                                            dense
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
                                <ModalFooter
                                    buttonType="submit"
                                    confirmText={'Siguiente'}
                                    onConfirm={handleSubmit}
                                    cancelText={"Atrás"}
                                    onCancel={onCancel}
                                />
                            </div>
                        </form>
                    )
                }}
            </Formik>
        </Grid>
    )
}